module.exports = __webpack_public_path__ + "img/health-icon.cdd592d8.svg";